import React, { useState } from "react";
import {
    Box,
    IconButton,
    Typography,
    Divider,
    ButtonGroup,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./styles.css";
import { downloadFileFromData } from "./helper";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

export const WatchDocModal = ({ open, handleClose, downloadFileInfo, isHeader, name, fileInfo }) => {
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.5);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const zoomIn = () => setScale((prev) => Math.min(prev + 0.25, 2));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.25, 0.5));
  const handleDownload = (file, fileName) => {
    const link = document.createElement("a");
    link.href = file;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Dialog
      open={open}
      maxWidth="1300px"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle sx={{ padding: "32px 32px 16px 32px" }} id="alert-dialog-title">
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: isHeader ? "space-between" : "right" }}>
          {isHeader && <Typography>Просмотр документа</Typography>}
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        {isHeader && <Typography sx={{ fontWeight: "500", fontSize: "20px", color: "#030C23" }}>{name}</Typography>}
      </DialogTitle>
      <DialogContent sx={{ padding: "0px 32px 10px 32px", margin: "24px 0px" }}>
        {fileInfo && (
          <>
            <Box display={"flex"} justifyContent={"space-between"}>
              <ButtonGroup size="small" sx={{ mr: 2 }}>
                <Button onClick={zoomOut} disabled={scale <= 0.5}>
                  -
                </Button>
                <Button sx={{ pointerEvents: "none" }}>{Math.round(scale * 100)}%</Button>
                <Button onClick={zoomIn} disabled={scale >= 3}>
                  +
                </Button>
              </ButtonGroup>
              <Button
                sx={{ height: "48px", gap: "8px" }}
                onClick={() => (isHeader ? downloadFileFromData(downloadFileInfo) : handleDownload(fileInfo, name))}
                className="btn btn-white-new"
              >
                Скачать
              </Button>
            </Box>

            <Box display={"flex"}>
              <Document file={fileInfo} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.from(new Array(numPages), (el, index) => (
                  <React.Fragment key={`page_${index + 1}`}>
                    <Page pageNumber={index + 1} scale={scale} />
                    {index < numPages - 1 && (
                      <Divider
                        sx={{
                          my: 3,
                          borderColor: "black",
                          borderBottomWidth: 1,
                          justifySelf: "center",
                          width: "80%",
                        }}
                      />
                    )}
                  </React.Fragment>
                ))}
              </Document>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
